<template>
    <div v-if="isEarlyAdopter && hasAnyLiveFlag">
        <!-- Transparent full-screen backdrop: any click outside the popover
             dismisses it (below the badge/popover, above the rest of the app). -->
        <div v-if="open" class="ql-ea-backdrop" @click="open = false"></div>
        <div class="ql-ea-badge-wrap">
            <button class="ql-ea-badge" @click="open = !open" title="Early-adopter preview">
                ✨ Early-adopter preview active
            </button>
            <div v-if="open" class="ql-ea-pop" @keydown.stop>
            <p class="ql-ea-pop-text">
                You're previewing pre-release features. If something's broken, you can turn the
                preview off and go back to the standard Cuelist.
            </p>
            <p class="ql-ea-pop-note">An admin can turn it back on later.</p>
            <div class="ql-ea-pop-actions">
                <button class="ql-ea-btn ghost" @click="open = false" :disabled="working">Keep it on</button>
                <button class="ql-ea-btn danger" @click="turnOff" :disabled="working">
                    {{ working ? 'Turning off…' : 'Turn off preview' }}
                </button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const EarlyAdopterBadge = {
    name: 'EarlyAdopterBadge',
    data: function() {
        return {
            open: false,
            working: false
        };
    },
    computed: {
        ...mapGetters(['isEarlyAdopter', 'hasAnyLiveFlag'])
    },
    methods: {
        turnOff: function() {
            this.working = true;
            this.$store.dispatch('pausePreview').then(() => {
                // isEarlyAdopter flips false via the live flag doc → this whole
                // component unmounts and the stable app returns, same session.
                this.open = false;
                this.working = false;
            }).catch((e) => {
                console.error('pausePreview failed', e);
                this.working = false;
            });
        }
    }
};

export default EarlyAdopterBadge;
</script>

<style lang="scss" scoped>
/*
 * Bottom-RIGHT, with the icon-only "Report a bug" FAB stacked above it.
 * Moved off the bottom-left corner because the project navigation panel is
 * fixed to the left edge and its footer buttons live at the bottom — this
 * badge sits at z-index 99999 and was covering them.
 *
 * Grouping the two early-adopter affordances in one corner keeps them
 * together, and avoids coupling this badge to the navigation panel's width,
 * which is user-resizable.
 */
.ql-ea-badge-wrap {
    position: fixed;
    bottom: 12px;
    right: 12px;
    z-index: 99999;
}
.ql-ea-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99998;
    background: transparent;
}
.ql-ea-badge {
    display: inline-block;
    padding: 6px 12px;
    border: none;
    border-radius: 16px;
    background-color: #0d2744;
    color: #5ecfdf;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.ql-ea-pop {
    position: absolute;
    bottom: 40px;
    /* Anchored right so the popover opens inward from the right edge instead
       of running off-screen now that the badge lives in the right corner. */
    right: 0;
    width: 260px;
    background: #fff;
    border-radius: 10px;
    padding: 14px 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}
.ql-ea-pop-text {
    margin: 0 0 6px;
    font-size: 13px;
    color: #333;
    line-height: 1.4;
}
.ql-ea-pop-note {
    margin: 0 0 12px;
    font-size: 12px;
    color: #888;
}
.ql-ea-pop-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
.ql-ea-btn {
    padding: 7px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
}
.ql-ea-btn.ghost {
    background: transparent;
    border-color: #ccc;
    color: #555;
}
.ql-ea-btn.danger {
    background-color: #b00020;
    color: #fff;
}
.ql-ea-btn.danger:disabled {
    opacity: 0.6;
    cursor: default;
}

/* Not on paper. Both of these are position: fixed, and a fixed element prints
 * on the FIRST PAGE of the output — which is exactly where Josh found them
 * (29 Aug 2026). They are app chrome for early adopters, not part of anyone's
 * script. Hidden here rather than in the print views because those styles are
 * scoped to their own components and cannot reach an overlay mounted by App.vue.
 */
@media print {
    .ql-ea-backdrop,
    .ql-ea-badge-wrap,
    .ql-ea-pop {
        display: none !important;
    }
}
</style>


// WEBPACK FOOTER //
// EarlyAdopterBadge.vue?469e3e02